module.exports = __webpack_public_path__ + "img/new_vcay.b801547e.jpg";